import Glightbox from 'glightbox/dist/js/glightbox';
import 'glightbox/dist/css/glightbox.css';

const gallery = new Glightbox({
    touchNavigation: true,
    loop: true,
});